import { render, staticRenderFns } from "./files-menu.vue?vue&type=template&id=5d4d9acc&scoped=true&"
import script from "./files-menu.vue?vue&type=script&lang=js&"
export * from "./files-menu.vue?vue&type=script&lang=js&"
import style0 from "./files-menu.vue?vue&type=style&index=0&id=5d4d9acc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4d9acc",
  null
  
)

export default component.exports